import { forwardRef } from 'react';

export const TwoSmallHousesIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1799 9.25733C15.3919 9.15662 15.6439 9.19543 15.8157 9.35527L20.9974 14.1746L31.6853 9.36687C31.8948 9.27262 32.1404 9.3127 32.3091 9.46868L37.8836 14.6232C38.0008 14.7316 38.0675 14.8841 38.0675 15.0437V34.5165C38.0675 34.8328 37.8111 35.0892 37.4948 35.0892H3.93296C3.61665 35.0892 3.36023 34.8328 3.36023 34.5165V15.2346C3.36023 15.0136 3.48749 14.8122 3.68719 14.7173L15.1799 9.25733ZM4.50568 15.5966V33.9437H36.922V15.2942L31.8096 10.567L21.1206 15.3751C20.9106 15.4696 20.6643 15.4291 20.4956 15.2722L15.3203 10.4588L4.50568 15.5966Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.22168 37.2656C1.22168 36.9493 1.4781 36.6929 1.79441 36.6929H39.9762C40.2925 36.6929 40.549 36.9493 40.549 37.2656C40.549 37.5819 40.2925 37.8383 39.9762 37.8383H1.79441C1.4781 37.8383 1.22168 37.5819 1.22168 37.2656Z"
        />
        <path d="M17.6403 22.9474H6.98755V34.211H17.6403V22.9474Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.41479 22.9474C6.41479 22.6311 6.67121 22.3746 6.98752 22.3746H17.6402C17.9566 22.3746 18.213 22.6311 18.213 22.9474V34.211C18.213 34.5273 17.9566 34.7837 17.6402 34.7837H6.98752C6.67121 34.7837 6.41479 34.5273 6.41479 34.211V22.9474ZM7.56025 23.5201V33.6383H17.0675V23.5201H7.56025Z"
        />
        <path d="M34.7073 22.9474H24.0546V34.211H34.7073V22.9474Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4819 22.9474C23.4819 22.6311 23.7384 22.3746 24.0547 22.3746H34.7074C35.0237 22.3746 35.2801 22.6311 35.2801 22.9474V34.211C35.2801 34.5273 35.0237 34.7837 34.7074 34.7837H24.0547C23.7384 34.7837 23.4819 34.5273 23.4819 34.211V22.9474ZM24.6274 23.5201V33.6383H34.1347V23.5201H24.6274Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.8854 14.28C21.2017 14.28 21.4581 14.5364 21.4581 14.8528V34.1346C21.4581 34.4509 21.2017 34.7073 20.8854 34.7073C20.569 34.7073 20.3126 34.4509 20.3126 34.1346V14.8528C20.3126 14.5364 20.569 14.28 20.8854 14.28Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.34226 3.93917C6.3776 3.65208 6.62145 3.4364 6.9107 3.4364H8.13252C8.41421 3.4364 8.65407 3.64124 8.69818 3.91945L9.57091 9.42438L15.2936 6.69931C15.4984 6.60176 15.7415 6.63434 15.9135 6.78237L21.3521 11.4646L21.8765 11.1211L22.7604 3.93917C22.7958 3.65208 23.0396 3.4364 23.3289 3.4364H24.5507C24.8324 3.4364 25.0723 3.64124 25.1164 3.91945L25.9891 9.42438L31.7117 6.69931C31.9178 6.6012 32.1624 6.63476 32.3344 6.78475L40.3908 13.8102C40.6292 14.0181 40.6539 14.3799 40.446 14.6183C40.2381 14.8567 39.8763 14.8814 39.6379 14.6735L31.8648 7.8951L25.7897 10.788C25.6266 10.8657 25.4365 10.8619 25.2766 10.7777C25.1168 10.6936 25.006 10.539 24.9778 10.3606L24.0616 4.58186H23.8354L22.981 11.5245C22.9604 11.6917 22.8673 11.8413 22.7264 11.9336L21.6191 12.6591C21.4055 12.799 21.1251 12.7807 20.9316 12.6141L15.449 7.89398L9.37148 10.788C9.20841 10.8657 9.01827 10.8619 8.85845 10.7777C8.69863 10.6936 8.58786 10.539 8.55958 10.3606L7.64344 4.58186H7.41726L6.56278 11.5245C6.54037 11.7066 6.43216 11.8668 6.27172 11.9557L1.99535 14.3229C1.71862 14.4761 1.37009 14.376 1.2169 14.0992C1.06371 13.8225 1.16386 13.474 1.44059 13.3208L5.46156 11.0949L6.34226 3.93917Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.41479 16.4182C6.41479 16.1019 6.67121 15.8455 6.98752 15.8455H17.5639C17.8802 15.8455 18.1366 16.1019 18.1366 16.4182V20.6182C18.1366 20.9345 17.8802 21.1909 17.5639 21.1909H6.98752C6.67121 21.1909 6.41479 20.9345 6.41479 20.6182V16.4182ZM7.56025 16.9909V20.0455H16.9912V16.9909H7.56025Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6309 16.4182C13.6309 16.1019 13.8873 15.8455 14.2036 15.8455H17.5636C17.8799 15.8455 18.1363 16.1019 18.1363 16.4182V20.6182C18.1363 20.9345 17.8799 21.1909 17.5636 21.1909H14.2036C13.8873 21.1909 13.6309 20.9345 13.6309 20.6182V16.4182ZM14.7763 16.9909V20.0455H16.9909V16.9909H14.7763Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.5967 16.4182C23.5967 16.1019 23.8531 15.8455 24.1694 15.8455H31.2712C31.5875 15.8455 31.844 16.1019 31.844 16.4182V20.6182C31.844 20.9345 31.5875 21.1909 31.2712 21.1909H24.1694C23.8531 21.1909 23.5967 20.9345 23.5967 20.6182V16.4182ZM24.7421 16.9909V20.0455H30.6985V16.9909H24.7421Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.8126 16.4182C30.8126 16.1019 31.069 15.8455 31.3853 15.8455H34.7453C35.0617 15.8455 35.3181 16.1019 35.3181 16.4182V20.6182C35.3181 20.9345 35.0617 21.1909 34.7453 21.1909H31.3853C31.069 21.1909 30.8126 20.9345 30.8126 20.6182V16.4182ZM31.9581 16.9909V20.0455H34.1726V16.9909H31.9581Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.44556 24.8182C7.44556 24.5019 7.70198 24.2455 8.01828 24.2455H16.4183C16.7346 24.2455 16.991 24.5019 16.991 24.8182C16.991 25.1345 16.7346 25.3909 16.4183 25.3909H8.01828C7.70198 25.3909 7.44556 25.1345 7.44556 24.8182Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.44556 27.8728C7.44556 27.5565 7.70198 27.3 8.01828 27.3H16.4183C16.7346 27.3 16.991 27.5565 16.991 27.8728C16.991 28.1891 16.7346 28.4455 16.4183 28.4455H8.01828C7.70198 28.4455 7.44556 28.1891 7.44556 27.8728Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.44556 31.3092C7.44556 30.9929 7.70198 30.7365 8.01828 30.7365H16.4183C16.7346 30.7365 16.991 30.9929 16.991 31.3092C16.991 31.6255 16.7346 31.8819 16.4183 31.8819H8.01828C7.70198 31.8819 7.44556 31.6255 7.44556 31.3092Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.6273 24.8182C24.6273 24.5019 24.8837 24.2455 25.2 24.2455H33.6C33.9164 24.2455 34.1728 24.5019 34.1728 24.8182C34.1728 25.1345 33.9164 25.3909 33.6 25.3909H25.2C24.8837 25.3909 24.6273 25.1345 24.6273 24.8182Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.6273 27.8728C24.6273 27.5565 24.8837 27.3 25.2 27.3H33.6C33.9164 27.3 34.1728 27.5565 34.1728 27.8728C34.1728 28.1891 33.9164 28.4455 33.6 28.4455H25.2C24.8837 28.4455 24.6273 28.1891 24.6273 27.8728Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.6273 31.3092C24.6273 30.9929 24.8837 30.7365 25.2 30.7365H33.6C33.9164 30.7365 34.1728 30.9929 34.1728 31.3092C34.1728 31.6255 33.9164 31.8819 33.6 31.8819H25.2C24.8837 31.8819 24.6273 31.6255 24.6273 31.3092Z"
          fill="white"
        />
      </svg>
    );
  },
);
